import jwtAuthAxios from "./auth/jwtAuth";

// Tipos de rack: las piezas con que se arma el plano de la bodega.
const rackTemplateServices = {};

rackTemplateServices.getTemplates = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/rack_templates${params}`);
    return data;
};

rackTemplateServices.createTemplate = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/rack_templates`, { rack_template: payload });
    return data;
};

rackTemplateServices.updateTemplate = async (id, payload) => {
    const { data } = await jwtAuthAxios.put(`/rack_templates/${id}`, { rack_template: payload });
    return data;
};

rackTemplateServices.deleteTemplate = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/rack_templates/${id}`);
    return data;
};

export default rackTemplateServices;
